import { Card, CardContent, CardHeader, CardTitle } from "@bowfast/ui/components/card";
import { motion } from "framer-motion";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { fadeUp } from "~/lib/animations";

export function SectionCard({
  icon: Icon,
  title,
  children,
  delay = 0,
}: Readonly<{
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  delay?: number;
}>) {
  return (
    <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay }}>
      <Card>
        <CardHeader className="flex-row items-center gap-3 pb-4">
          <div className="flex size-8 items-center justify-center rounded-lg bg-abyss-50 dark:bg-abyss-800">
            <Icon className="size-4 text-abyss-500" />
          </div>
          <CardTitle className="font-heading text-[0.9375rem] font-semibold">{title}</CardTitle>
        </CardHeader>
        <CardContent className="pt-0">{children}</CardContent>
      </Card>
    </motion.div>
  );
}
